import React, { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import {
  RouterProvider,
} from "react-router-dom";
import { routesAdmin, routesPlayer, routesLogin } from "./Routes"
import { QueryClientProvider } from 'react-query';
import { queryClientConfig } from './Pages/query-client-config';
import { SelectedIdProvider } from './Hooks/Admin/useContextos';
import useLockScreenOrientation from './Hooks/useLockScreenOrientation';
import Pusher from "pusher-js";
import { notification } from "antd";

const App = () => {
  useLockScreenOrientation('portrait');
  const router = localStorage.getItem("token") ? (localStorage.getItem("isAdmin") == "true" ? routesAdmin : routesPlayer) : routesLogin

  const WEBSOCKET_KEY = import.meta.env.VITE_WEBSOCKET_KEY;
  const WEBSOCKET_CLUSTER = import.meta.env.VITE_WEBSOCKET_CLUSTER;
  const dataUser = JSON.parse(localStorage.getItem('dataUser'));
  useEffect(() => {
      const pusher = new Pusher(WEBSOCKET_KEY, {
          cluster: WEBSOCKET_CLUSTER
      });

      const channel = pusher.subscribe("logros");
      channel.bind("App\\Events\\LogroDesbloqueado", (data) => {
          if (dataUser?.id == data.id) {
            notification.open({
              message: data.titulo,
              description: data.mensaje,
              style: { zIndex: 7001 },
            });
          }
      });

      return () => {
          channel.unbind_all();
          channel.unsubscribe();
      };
  }, []);

  return (
    <SelectedIdProvider>
      <QueryClientProvider client={queryClientConfig}>
        <StrictMode>
          <RouterProvider router={router} />
        </StrictMode>
      </QueryClientProvider>
    </SelectedIdProvider>
  );
};

createRoot(document.getElementById('root')).render(<App />);
